import React, { createContext, useContext, useMemo, useState } from 'react';

interface SunlightContextValue { sunDate: Date; setSunDate: (d: Date) => void }

const SunlightContext = createContext<SunlightContextValue | null>(null);

export const SunlightProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [sunDate, setSunDate] = useState<Date>(new Date());
  const value = useMemo(() => ({ sunDate, setSunDate }), [sunDate]);
  return <SunlightContext.Provider value={value}>{children}</SunlightContext.Provider>;
};

export function useSunlight() {
  const ctx = useContext(SunlightContext);
  if (!ctx) { throw new Error('useSunlight must be used within SunlightProvider'); }
  return ctx;
}
